import { LocalStorage } from '@lean-body/src/infra';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { liveEventId } from '../../domain';
import { routes } from '../../route';
import { ZIndex } from '../constants';
import { FixedFooterBanner } from '../molecules/fixed_footer_banner';
import { Colors } from '../styles';
import { StoreBanner } from '@lean-body/components/organisms';
import { isNativeWeb } from '@lean-body/src/util';
import { FooterItem } from './footer_item';
import { useMissionNotificationStore } from '../stores/mission_notification_store';
export const FIXED_FOOTER_HEIGHT = 60;
export const FixedFooter = (props) => {
    const styles = StyleSheet.create({
        container: {
            backgroundColor: Colors.White,
            zIndex: ZIndex.Footer,
            position: 'fixed',
            bottom: 0,
            width: '100%',
            height: FIXED_FOOTER_HEIGHT,
            display: 'flex',
            borderTop: `1px solid ${Colors.BorderLightGray}`,
        },
        banner: {
            zIndex: ZIndex.StoreBanner,
            position: 'fixed',
            bottom: FIXED_FOOTER_HEIGHT,
            width: '100%',
        },
    });
    const { footer } = props;
    const hasUnviewedMissions = useMissionNotificationStore((state) => state.hasUnviewedMissions);
    const location = useLocation();
    const isSM = useSmMediaQuery();
    const localStorage = new LocalStorage();
    const isLiveLessonPage = routes.LIVE_GROUP.matchPath(location.pathname);
    const hasLiveLessonNotification = !isLiveLessonPage && !!(footer === null || footer === void 0 ? void 0 : footer.hasLiveLessonNotification);
    if (isLiveLessonPage && (footer === null || footer === void 0 ? void 0 : footer.hasLiveLessonNotification)) {
        localStorage.saveLiveScheduleTabNoticed();
    }
    return (React.createElement(React.Fragment, null,
        isNativeWeb() && (React.createElement(StoreBanner, { onClickHideButton: props.onClickAppstoreBannerHideButton, classObject: styles.banner })),
        React.createElement("div", { className: css(styles.container), id: "footer" },
            routes.TOP.matchPath(location.pathname) && props.fixedBannerDisplayable && isSM && (React.createElement(FixedFooterBanner, { imgSrc: `${props.config.cdnBaseURL}/banner/lb-hw_banner-pr-home.jpg`, link: routes.LIVE_LESSON.compile({ id: `${liveEventId()}` }), hideFixedBanner: props.hideFixedBanner })),
            React.createElement(FooterItem, { linkTo: routes.TOP.path, iconSrc: '/assets/images/icons/home.svg', iconSrcActive: '/assets/images/icons/home_light_blue.svg', label: 'HOME', isActive: routes.TOP.matchPath(location.pathname) }),
            React.createElement(FooterItem, { linkTo: routes.SEARCH.path, iconSrc: '/assets/images/icons/search.svg', iconSrcActive: '/assets/images/icons/search_light_blue.svg', label: '見つける', isActive: routes.SEARCH_GROUP.matchPath(location.pathname) }),
            React.createElement(FooterItem, { linkTo: routes.LIVE_SCHEDULE.path, iconSrc: '/assets/images/icons/live_stream.svg', iconSrcActive: '/assets/images/icons/live_stream_light_blue.svg', label: 'LIVE', isActive: routes.LIVE_GROUP.matchPath(location.pathname), hasNotification: hasLiveLessonNotification }),
            React.createElement(FooterItem, { linkTo: routes.MY_LESSON.path, iconSrc: '/assets/images/icons/my_lesson.svg', iconSrcActive: '/assets/images/icons/my_lesson_light_blue.svg', label: 'MYレッスン', isActive: routes.MY_LESSON.matchPath(location.pathname) }),
            React.createElement(FooterItem, { linkTo: routes.ACTIVITY.path, iconSrc: '/assets/images/icons/activity.svg', iconSrcActive: '/assets/images/icons/activity_light_blue.svg', label: 'アクティビティ', isActive: routes.ACTIVITY_GROUP.matchPath(location.pathname), isLongLabel: true, hasNotification: hasUnviewedMissions }))));
};
